module.exports = __webpack_public_path__ + "static/media/bell-active-icon.ff9f5428.svg";